import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import template from '@bingads-webui-campaign-legacy/auto-targets/template/category-targets/category-grid.pug';
import addToListTmpl from '@bingads-webui-campaign-legacy/auto-targets/template/category-targets/addToList.pug';
import categoryNameTmpl from '@bingads-webui-campaign-legacy/auto-targets/template/category-targets/categoryName.pug';
import categoryNameHeaderTmpl from '@bingads-webui-campaign-legacy/auto-targets/template/category-targets/categoryNameHeader.pug';

import pgrid from '@bingads-webui-component-legacy/github/modules/projection-grid/module/projection-grid';
import jsdataCampaign from '@bingads-webui-component-legacy/js-data-campaign/index';

import paginationPlugin from '@bingads-webui-campaign-legacy/bingadsgrid/plugin/pagination';
import paginationTemplate from '@bingads-webui-component-legacy/bingads-grid/template/pagination.pug';
import searhBoxPlugin from '@bingads-webui-campaign-legacy/auto-targets/view/category-targets/autoSuggestionSearchBoxPlugin';

import uiBlocker from '@bingads-webui-component-legacy/uiblocker/service/uiBlocker';
import convert from '@bingads-webui-campaign-legacy/auto-targets/service/convert';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';

import instrumentationService from '@bingads-webui-static-legacy/instrumentation/index';
import instrumentationSettings from '@bingads-webui-static-legacy/instrumentation/campaignSchemaAndSetting';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';

import { DoubleListA11yHacker } from '@bingads-webui-campaign-legacy/auto-targets/view/double-list-a11y-hacker';
import { languageCodeMap } from '@bingads-webui-campaign-legacy/auto-targets/view/category-targets/const';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');
const categorySchema = window.globalLegacySchema.get('CategoryTarget');

export default class Categories extends Backbone.View {
  initialize(options = {}) {
    this.options = options;
    this.previousCategoryScope = [];
    this.currentCategoryScope = ko.observable('');
    this.odataQuery = this._convert2JSDataQuery(this.options.setting);
    this.odataOptions = {
      path: 'AdInsight/V2/',
      url: '/Customers(:advertisercustomer_id)/Accounts(:account_id)/Default.DSACategoryList',
    };
    this.isInternalUpdate = false;
    this.isContainerHidden = options.isContainerHidden;
  }

  //this is work around, RnR team will convert it
  _convert2JSDataQuery({
    Language = 'en',
    DomainName = '',
  }) {
    let domainName = _.isString(DomainName) ? DomainName.toLowerCase() : '';
    let languageCode = _.result(languageCodeMap, Language, Language);

    return {domainName, languageCode};
  }

  render() {
    const pageSize = 1000;
    const self = this;
    const minRoundCoverage = 0.0001;

    _.invoke([instrumentationService], 'startScenario', instrumentationSettings.SCENARIONAME.DynamicSearchAd);
    _.invoke([instrumentationService], 'startActivity', instrumentationSettings.ACTIVITYNAME.LoadCategoryGrid);

    self.$el.html(template({ i18n }));
    self.$grid = self.$('.grid-table');
    self.grid = pgrid.factory()
      .use(paginationPlugin)
      .use(searhBoxPlugin)
      .create({
        name: i18n.get('DSA_AutoTargets_Category_Grid_Name'),
        el: self.$grid,
        dataSource: {
          type: 'js-data',
          resource: jsdataCampaign.CategoryTarget,
          schema: categorySchema,
          query: self.odataQuery,
          options: self.odataOptions,
        },
        columns: [{
          name: 'CategoryName',
          sortable: true,
          filterable: true,
          headerAttributes: {
            'aria-label': i18n.get('DSA_AutoTargets_Category_Grid_Column_Header_Name'),
            'tabindex': '0',
            'data-name': 'CategoryName',
            'aria-sort': 'none',
            'class': 'clickable',
          },
          popupId: 'pop_BA_CampaignCreate_Keywords_RecommendedCatsColumn',
          headerTemplate() {
            return categoryNameHeaderTmpl({title: i18n.get('DSA_AutoTargets_Category_Grid_Column_Header_Name'), i18n});
          },
          template(local) {
            const categoryName = local.model.CategoryName;

            return categoryNameTmpl({
              isParent: (/.*\/$/).test(categoryName),
              categoryNames: _.map(convert.multiLine(categoryName), (line, index, list) => {
                return {
                  name: line,
                  isTail: index === list.length - 1,
                };
              }),
              ariaLabel: i18n.get('DSA_AutoTargets_Category_Grid_To_Next_Level').replace('{0}', categoryName.replace(/\/$/, '')),
            });
          },
        }, {
          name: 'Coverage',
          title: i18n.get('DSA_AutoTargets_Category_Grid_Column_Header_Coverage'),
          sortable: true,
          filterable: false,
          popupId: 'pop_BA_CampaignCreate_Keywords_WebsiteCoverage',
          headerAttributes: {
            'aria-label': i18n.get('DSA_AutoTargets_Category_Grid_Column_Header_Coverage'),
            'tabindex': '0',
            'data-name': 'Coverage',
            'aria-sort': 'none',
            'class': 'clickable',
          },
          template(local) {
            return addToListTmpl({
              i18n,
              value: local.model.Coverage < minRoundCoverage && local.model.Coverage > 0 ? i18n.get('Website_Coverage_Less_01') : decimal.fromFloatToPercentString(local.model.Coverage * 100),
              hideAddToList: self.options.hideAddToList,
              disableItem: _.find(_.result(self.options, 'selectedItems', []), (selected) => {
                return selected.type === 'category' &&
                  _.first(selected.conditions).ArgumentOperand.toString() === local.model.CategoryName;
              }),
              ariaLabel: `${i18n.getString('DoubleListBox_Select')} ${local.model.CategoryName.replace(/\/$/, '')}`,
            });
          },
        }],
        pageable: {
          pageSize,
          availablePageSizes: [pageSize],
        },
        pluginsConfig: {
          autoSuggestionSearchBox: {
            el: self.$('.autoSuggSearchBoxContainer'),
            dataSource: () => {
              //TODO: remove the log after debugging
              if (_.isEmpty(self.odataQuery.domainName)) {
                const stack = new Error().stack;

                instrumentationService.logError('Categories-AutoSuggestion', `domainName is empty\t${stack}`);
              }

              return jsdataCampaign.CategoryTarget.findAll({
                query: _.extend({$select: 'CategoryName', $top: 20000}, self.odataQuery),
              }, _.defaults({cacheResponse: false}, self.odataOptions));
            },
          },
          pagination: {
            container: self.$('.pager'),
            template: paginationTemplate,
          },
        },
      });

    self.grid.gridView.on('layout:click:cell', self._gridClicked.bind(self));
    self.grid.gridView.on('update:beginning', () => {
      if (this.isInternalUpdate) {
        this.isInternalUpdate = false;
      } else {
        self.uiBlockerToken = uiBlocker.block(self.$grid);
      }
    });
    self.grid.gridView.on('layout:click:header', (event) => {
      const name = this.$(event.target).closest('th').attr('data-name');

      self.grid.gridView.once('update:finished', () => _.defer(() => {
        const el = this.$(`th[data-name="${name}"]`).get(0);
        const columns = _.chain(self.grid.gridView)
          .result('layout')
          .result('data')
          .result('columns')
          .value();
        const targetColumn = columns[name];
        const dir = _.chain(targetColumn)
          .result('$orderby')
          .result('dir')
          .value();
        const isAsc = dir === 1;
        const isDesc = dir === -1;

        if (el) {
          el.focus();
        }

        if (isAsc) {
          this.$(el).attr('aria-sort', 'ascending');
        } else if (isDesc) {
          this.$(el).attr('aria-sort', 'descending');
        } else {
          this.$(el).attr('aria-sort', 'none');
        }
      }));
    });

    if (ko.isObservable(self.isContainerHidden)) {
      self.isContainerHidden.subscribe((newValue) => {
        if (self.uiBlockerToken && newValue === false) {
          self.uiBlockerToken = uiBlocker.block(self.$grid, self.uiBlockerToken);
        }
      });
    }

    const a11yHacker = new DoubleListA11yHacker({
      rootSelector: '.category-container .grid-table',
      listViewSelector: '.category-container .grid-table table.grid tbody',
      itemSelector: 'tr',
      interactableElementSelector: 'a.next-level, td.col-Coverage .arrow-button.clickable',
      listAriaLabel: i18n.get('DSA_AutoTargets_Category_Grid_Name'),
    });

    self.grid.gridView.on('update:finished', () => {
      _.defer(() => {
        a11yHacker.refresh();
      });

      const totalRecordCount = self.grid.projection.data.attributes.count;
      const searchText = self.grid.autoSuggestionSearchBox.searchBox.ko_model.value();
      const isCategoriesEmpty = totalRecordCount === 0 && _.isEmpty(searchText);

      if (isCategoriesEmpty) {
        self.$('.grid-container').hide();
        _.invoke([instrumentationService], 'startActivity', instrumentationSettings.ACTIVITYNAME.NoCategoryLoadedForWebsite);
      } else {
        self.$('.grid-container').show();
      }
      instrumentationService.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'IsCategoriesEmpty', `${isCategoriesEmpty}`);

      self.trigger('categoryLoaded', isCategoriesEmpty);

      self.grid.pagination.itemCount = totalRecordCount;

      if ( totalRecordCount < pageSize) {
        self.grid.pagination.$el.hide();
      }
      if (self.uiBlockerToken) {
        setTimeout(() => {
          uiBlocker.unblock(self.$grid, self.uiBlockerToken);
          self.uiBlockerToken = null;
        }, 1);
      }

      if (self.currentCategoryScope()) {
        const $prevLevelIcon = self.$('.glyphicon-arrow-left');

        $prevLevelIcon.css('display', 'block');
        $prevLevelIcon.get(0).focus();
      }
    });
    self.grid.gridView.render({ fetch: !_.isEmpty(this.odataQuery.domainName) });
    self.grid.pagination.render();
    self.grid.autoSuggestionSearchBox.render();
    if (!_.isEmpty(this.odataQuery.domainName)) {
      this.grid.autoSuggestionSearchBox.load().catch(() => {
        self.$('.category-error').show();
      });
    }
    self.currentCategoryScope.subscribe((newValue) => {
      self.grid.projection.set({
        'jsdata.query': newValue ? _.extend({ category: newValue }, self.odataQuery) : self.odataQuery,
        'page.number': 0,
      });
    });
    self.$('.grid-table').on('click', '.glyphicon-arrow-left', (e) => {
      self.currentCategoryScope(self.previousCategoryScope.pop());
      if (!self.currentCategoryScope()) {
        self.$('.glyphicon-arrow-left').css('display', 'none');
      }
      e.stopPropagation();
    });
    self.on('update:setting', (setting) => {
      if (!_.isEmpty(setting.DomainName)) {
        self.odataQuery = this._convert2JSDataQuery(setting);
        self.grid.projection.set('jsdata.query', this.odataQuery);
        self.$('.category-error').hide();
        self.grid.autoSuggestionSearchBox.searchBox.ko_model.value('');
        self.grid.autoSuggestionSearchBox.load().catch(() => {
          self.$('.category-error').show();
        });

        // check the disable status of category option in case the request is cached
        // and the grid may not be reloaded, thus the categoryLoaded event is not triggered
        const totalRecordCount = self.grid.projection.data.attributes.count;
        const searchText = self.grid.autoSuggestionSearchBox.searchBox.ko_model.value();
        const isCategoriesEmpty = totalRecordCount === 0 && _.isEmpty(searchText);

        self.trigger('categoryLoaded', isCategoriesEmpty);
      }
    });
    self.on('update:items', () => {
      this.isInternalUpdate = true;
      if (!_.isEmpty(this.odataQuery.DomainName)) {
        self.grid.gridView.render({ fetch: true });
      }
    });
    return self;
  }
  show() {
    this.$el.show();
    return this;
  }
  hide() {
    this.$el.hide();
    return this;
  }
  _gridClicked(e, data) {
    if (e.target && e.target.className && e.target.className.indexOf('arrow-button') > -1) {
      if (e.target.className.indexOf('form-control-disabled') < 0) {
        this.trigger('selectTarget', this._convertToTarget(data));
      }
    } else if (e.target && e.target.className && e.target.className.indexOf('next-level') > -1 && data.column.property === 'CategoryName' && _.last(data.model.CategoryName) === '/') {
      this.previousCategoryScope.push(this.currentCategoryScope());
      this.currentCategoryScope(data.model.CategoryName);
    }
  }
  _convertToTarget(data) {
    return {
      conditions: [{Operand: 'Category', ArgumentOperand: data.model.CategoryName}],
      type: 'category',
    };
  }
}
